import React from 'react'
import { useLocation, useOutletContext, useParams } from 'react-router-dom';
import DashboardHeader from '../components/Other/DashboardHeader';
import PageHeaderTitle from '../components/pages/PageHeaderTitle';
import FollowersSection from '../components/Other/FollowersSection';

const FollowersPage = () => {
  const [sidebarToggle] = useOutletContext();
    const location = useLocation();
  const user_name = location.state?.user_name;

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title={`${user_name}'s Followers`} />
      <FollowersSection />
    </>
  );
}


export default FollowersPage
